module.exports = __webpack_public_path__ + "media/images/emblems/Aeschi_bei_Spiez-coat_of_arms-549862f556b43e79bc2db0c2f66b6964.svg";